// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"dp-ZTNUVRHH","desc":"dp-HhqUz8ZY"};